import React from 'react'
import { SliderWrapper, Progress, Tooltip, Slider } from './ElementsStyles'
import { ReactComponent as DiceSVG } from '.././../../../lib/assets/red_diamond.svg'

export default function SliderRange() {
  return (
    <>
      <SliderWrapper>
        <Slider>
          <Progress>
            <DiceSVG />
            <Tooltip>
              <p>84.00</p>
            </Tooltip>
          </Progress>
        </Slider>
      </SliderWrapper>
    </>
  )
}
